export default "/static/frontend/images/images/dbe9d63cb31ca758d7f5577dbe525376-qr-code-simple.png";